import InvoicesView from '../../Containers/Invoices/view/invoicesView';

const InvoiceViewScreen = () => {
  return (
    <InvoicesView />
  );
};

export default InvoiceViewScreen;
